export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '喵绅士是一个什么样的平台？',
    answer: '喵绅士是一个专为爱猫人士打造的高雅精品平台，汇聚猫咪文化、绅士美学与精致生活方式。我们提供专业的养猫知识、精选猫咪好物推荐以及优雅的铲屎官生活指南，帮助每一位爱猫人活得像一位真正的喵绅士。',
  },
  {
    question: '喵绅士的内容多久更新一次？',
    answer: '我们保持每周至少更新3篇优质原创内容，涵盖猫咪文化、养猫知识、生活美学等多个领域。订阅我们的资讯邮件，您将第一时间收到最新文章推送。',
  },
  {
    question: '如何成为一名真正的喵绅士？',
    answer: '成为喵绅士不在于拥有多少名贵猫咪用品，而在于以下几点：对猫咪怀有真诚的爱与尊重；注重生活品质与审美品味；持续学习科学的养猫知识；以优雅从容的态度对待生活。这是一种由内而外的生活哲学。',
  },
  {
    question: '喵绅士推荐的产品在哪里可以购买？',
    answer: '我们在「精选好物」板块中推荐的产品，大部分都可以通过文章内提供的链接直接购买。我们严格筛选合作伙伴，确保推荐的每一件产品都符合喵绅士的品质标准——兼具实用性、美观性与安全性。',
  },
  {
    question: '我可以向喵绅士投稿吗？',
    answer: '当然可以！我们非常欢迎热爱猫咪、有独特见解的作者投稿。无论您是分享养猫经验、猫咪故事，还是猫咪相关的艺术创作，都可以通过「关于我们」页面中的联系方式与我们沟通。投稿一经采用，我们将支付稿酬。',
  },
  {
    question: '喵绅士是否有线下活动？',
    answer: '我们定期在全国主要城市举办喵绅士线下沙龙活动，包括猫咪主题品茶会、猫宅设计分享会、猫咪摄影工作坊等。活动信息会第一时间在官网和邮件资讯中发布，敬请关注。',
  },
];